export { GlobalProvider } from './GlobalProvider';
export { useGlobalContext } from './useGlobalContext';

export type { GlobalInitialStateTypes } from './globalInitialState';
